import type { ReactNode } from "react";

export interface ProductPurchaseNewViewProps {
  /** The wired guest purchase flow (routed modal + Inertia form) supplied by the container. */
  children: ReactNode;
}

/**
 * Presentational shell for the product guest-purchase modal route. This page is a thin
 * wrapper: all wiring (route path, Inertia form, routed modal) lives in the container
 * (`new.tsx`) and is passed in as `children`; this simply renders that composition.
 */
export function ProductPurchaseNewView({ children }: ProductPurchaseNewViewProps) {
  return <>{children}</>;
}
